import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { confirmAlert } from "react-confirm-alert";
import { Button, Flex, Text, rem } from "@mantine/core";
import { useAtom } from "jotai";

import createPaymentIntent from "utils/createPaymentIntent";

import { ErrorAlert, Loader, UserDetails } from "components";
import iDEALIcon from "../../assets/icon/iDEAL.png";

import { BOOK_SERVICE_BODY, BOOKING_ID, STRIPE_AC_ID } from "constants";
import { ROUTE_NAMES } from "routes/names";
import { ChevronsIconLeft } from "assets/icon";
import EventInfoCard from "views/TicketBooking/EventInfoCard";
import EventBuyingSummary from "views/TicketBooking/EventBuyingSummary";
import { step } from "store/atoms";
import { createBookingBody } from "core/methods";
import { IDEAL_BANK_NAMES } from "constants";
import { TwAppBar, TwButton, TwFooter } from "components/tailwind";
import TandCLink from "components/TandCLink";
import { updatestate } from "store/reducer";
import { BOOKINK_CART } from "constants";
import { BOOKINK_LINK } from "constants";
import { useTranslation } from "react-i18next";

export default function IdealPayment() {

  const { t } = useTranslation();
  const BOOKINKLINK = window.localStorage.getItem(BOOKINK_LINK);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const reduxstate = useSelector((state) => state.State);
  const stripeAcId = window.localStorage.getItem(STRIPE_AC_ID);

  if (!BOOKINKLINK || BOOKINKLINK == null || BOOKINKLINK === "null") {
    navigate(`/`, { replace: true });
  } else if ((!stripeAcId || stripeAcId == null || !location.state || location.state == null) && BOOKINKLINK && BOOKINKLINK !== "") {
    navigate(`${BOOKINKLINK}`, { replace: true });
  }


  const { idealBank } = location.state || {};

  const [stripe, setStripe] = useState(null);
  const [, setEventStep] = useAtom(step);
  const [processing, setProcessing] = useState(false);

  async function getClientSecret() {
    const eventBookingPayload = createBookingBody({
      ...reduxstate.addParticipantData,
      paymentStatus: "Paid",
      paymentMethod: "ideal",
      paymentMode: "Online",
    });

    const body = {
      eventScheduleId: reduxstate.id,
      selectedEventPricing: reduxstate.selectedEventPricing
        .filter((item) => item.bookingQty && item.bookingQty > 0)
        .map(({ bookingQty, totalPrice, ticketType }) => ({
          bookingQty,
          totalPrice,
          ticketType,
        })),
      selectedAddonsPricing: eventBookingPayload.selectedAddonsPricing,
      eventBookingPayload,
    };

    // console.log("TOTALPRICE", reduxstate.totalPrice);
    const res = await createPaymentIntent({
      amount: Number(reduxstate.totalPrice),
      body,
      paymentMethod: "ideal",
    });
    return res;
  }

  useEffect(() => {
    setProcessing(true);
    loadStripe(
      process.env.REACT_APP_ENVIRONMENT === "PROD"
        ? process.env.REACT_APP_STRIPE_LIVE_KEY
        : process.env.REACT_APP_STRIPE_TEST_KEY,
      stripeAcId ? { stripeAccount: stripeAcId } : undefined
    ).then((stripeRes) => {
      setStripe(stripeRes);
    });
    setProcessing(false);
  }, [stripeAcId]);

  const handlePay = async () => {
    setProcessing(true);
    const getClientSecretResponse = await getClientSecret();
    const { client_secret, orderReferenceId, } = getClientSecretResponse

    if (getClientSecretResponse.error == true) {
      confirmAlert({
        customUI: ({ onClose }) =>
          ErrorAlert({
            onClose: () => {
              onClose();
              setProcessing(false);
            },
            error: getClientSecretResponse.message,
            serverError: false,
          }),
        closeOnEscape: false,
        closeOnClickOutside: false,
      });
      return;
    }

    window.localStorage.setItem(BOOKING_ID, orderReferenceId);

    let return_url = process.env.REACT_APP_STRIPE_RETURN_URL_DEV;

    switch (true) {
      case process.env.REACT_APP_ENVIRONMENT === "PRE_STAGING":
        return_url = process.env.REACT_APP_STRIPE_RETURN_URL_PRE_STAGING;
        break;
      case process.env.REACT_APP_ENVIRONMENT === "STAGING":
        return_url = process.env.REACT_APP_STRIPE_RETURN_URL_STAGING;
        break;
      case process.env.REACT_APP_ENVIRONMENT === "PROD":
        return_url = process.env.REACT_APP_STRIPE_RETURN_URL_PROD;
        break;
      default:
        break;
    }

    const { error, paymentIntent } = await stripe.confirmIdealPayment(
      client_secret,
      {
        payment_method: {
          ideal: {
            bank: idealBank,
          },
        },
        return_url: `${return_url}${ROUTE_NAMES.PAYMENT_CHECK}`,
      }
    );

    if (paymentIntent) {
      if (paymentIntent.status === "succeeded") {
        navigate(ROUTE_NAMES.PAYMENT_COMPLETE, {
          state: { paymentSuccess: true },
        });
      }
    }

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.

    if (error.type === "card_error" || error.type === "validation_error") {
      confirmAlert({
        customUI: ({ onClose }) =>
          ErrorAlert({
            onClose: () => {
              onClose();
              navigate(-1);
            },
            error: error.message,
            serverError: false,
          }),
        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    } else {
      confirmAlert({
        customUI: ({ onClose }) =>
          ErrorAlert({
            onClose: () => {
              onClose();
              navigate(-1);
            },
            error: "An unexpected error occurred.",
            serverError: false,
          }),
        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    }
    setProcessing(false);
  };

  const handleChangePaymentMethod = () => {
    // setEventStep(3);
    setEventStep(2);
    navigate(-1, { replace: true });
  };

  useEffect(() => {
    let bookink_cart = window.localStorage.getItem(`${BOOKINK_CART}`);

    if (bookink_cart) {
      dispatch(updatestate({ ...Object.keys(bookink_cart).length > 0 ? JSON.parse(bookink_cart) : {} }));
    }

  }, []);

  if (!stripe) {
    return (
      <div className="ticket-view-loading">
        <Loader />
      </div>
    );
  }

  return (
    <div className="[wrapper] max-w-md w-full">
      <TwAppBar
        isBackBtnShow={true}
        onBackClick={() => { navigate(-1) }}
        title={t("payment.R&P")}
      />
      <div className="content">
        <div className="flex flex-col gap-6 bg-white">
          <EventInfoCard
            reduxstate={reduxstate}
            selectedStep={5}
            isReadMore={false}
            isReview={true}
            toggleReadMore={() => { }}
          />
          <UserDetails />

          <EventBuyingSummary reduxstate={reduxstate} />
          <div className=" pb-4 flex flex-col gap-4">
            <div className="px-4 bg-white">
              <div className="flex justify-between items-center gap-4 border-2 border-gray-300 rounded-xl p-4">
                <div className="flex gap-2 items-center">
                  <img
                    src={iDEALIcon}
                    alt="iDEAL icon"
                    style={{ width: 36, height: 36 }}
                  />
                  <div className="flex flex-col">
                    <div className="text-lg font-bold">
                      iDEAL
                    </div>
                    <div className="text-sm text-gray-500">
                      {IDEAL_BANK_NAMES[idealBank]}
                    </div>
                  </div>
                </div>
                <TwButton
                  variant={"secondary-link"}
                  className="!text-lg"
                  onClick={handleChangePaymentMethod}
                >
                  {t("common.change")}
                </TwButton>
              </div>
            </div>
          </div>
        </div>
        <TwFooter isShowReservation={true}>
          <div className="p-4 bg-white flex flex-col gap-2">
            <TwButton
              className="w-[96%]"
              onClick={handlePay}
              disabled={processing}
              actionLoading={processing}
            >
              {t("button.payAndConfirm")}
            </TwButton>
            <TandCLink />
          </div>
        </TwFooter>
      </div>
    </div>
  );
}
